import React, { ButtonHTMLAttributes } from 'react';
import styles from './linkButton.module.scss';

const LinkButton: React.FC<ButtonHTMLAttributes<HTMLButtonElement>> = props => {
  const { className, ...otherProps } = props;
  return (
    <button className={`${styles.link} ${className}`} {...otherProps}>
      {props.children}
    </button>
  );
};

export default LinkButton;
